/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const maxAvgCheckSchema = z.object({
	value: z.number(),
	organization_id: z.uuid().nullable(),
	organization_name: z.string().nullable(),
});
